module.exports = __webpack_public_path__ + "static/media/IMG_3614.f499a7de.jpg";